export const messages = {
  title: '待办',
  empty: '还没有任何待办，添加第一条试试',
  loading: '加载中…',
  errorRetry: '加载失败，点击重试'
} as const
